import React from 'react';
import { useIntl } from 'react-intl';
import KnovioPreviewSpinner from '../../../../global/spinner/knovio-preview-spinner';
import './modal-loading-screen.scss';

const ModalLoadingScreen = ({ loadingTitle, loadingInfo }): JSX.Element => {
    const intl = useIntl();

    return (
        <div className='modal-loader-screen'>
            <div className='oe-form-field__info modal-loader-screen__spinner'>
                <KnovioPreviewSpinner classname='modal-loader-screen__spinner' />
                {intl.formatMessage(loadingTitle)}
            </div>
            <div className='oe-form-field__info modal-loader-screen__spinner-time-text'>
                {intl.formatMessage(loadingInfo)}
            </div>
        </div>
    );
};

export { ModalLoadingScreen };